var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExprienceDeco3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 115,
    viewBox: "0 0 164 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 5,
    r: 5,
    fill: "#E8DCFF"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 65,
    r: 5,
    fill: "#E8DCFF"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 35,
    r: 5,
    fill: "#E8DCFF"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 95,
    r: 5,
    fill: "#E8DCFF"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 20,
    r: 5,
    fill: "#E8DCFF"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 80,
    r: 5,
    fill: "#E8DCFF"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 50,
    r: 5,
    fill: "#E8DCFF"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 110,
    r: 5,
    fill: "#E8DCFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExprienceDeco3);
export default __webpack_public_path__ + "static/media/exprience-deco3.bbc4184ebcb0b738bcfb3dd7841d5e24.svg";
export { ForwardRef as ReactComponent };